import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SaveIpv6Group } from '../../shared/components';

export type CreateIpv6GroupPageProps = {};

const CreateIpv6GroupPage: React.FC<CreateIpv6GroupPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_grupoipv6);

  return <SaveIpv6Group titlePage="Crear Grupo IPv6" />;
};

export default CreateIpv6GroupPage;
